export const classNameMerge = (blockClass: string, additionalClass: string | undefined): string => {
  if (additionalClass) return `${blockClass} ${additionalClass}`;
  return blockClass;
};
